import * as React from "react";
const SvgCheckLight = (props) => /* @__PURE__ */ React.createElement("svg", { height: 11, viewBox: "0 0 16 11", width: 16, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m5.75014 8.27557 8.04296-8.043881 1.2382 1.237251-9.28116 9.28116-5.568499-5.56854 1.237249-1.23725z" }));
export default SvgCheckLight;
